import { Modal } from "bootstrap";
import Appsignal from "@appsignal/javascript";
// import * as Sentry from '@sentry/browser';

// Sentry.init({
//   dsn: "https://ef7817fb0cbc47cd3a4e3e570100e01f@o4508359258669056.ingest.de.sentry.io/4508359442825296",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   environment: process.env.NODE_ENV || "development",
//   debug: true,
// });
import { plugin } from "@appsignal/plugin-path-decorator";

const appsignal = new Appsignal({ key: "de00ae58-b69e-478d-8d07-05566e954c4c" });
appsignal.use(plugin());
window.appsignal = appsignal;
var videoModalElements = document.querySelectorAll(".modal[id^=video-modal]");
if (videoModalElements) {
  videoModalElements.forEach((videoModalElement) => {
    videoModalElement.addEventListener("hidden.bs.modal", function (event) {
      event.target.querySelector("iframe").contentWindow.postMessage('{"event":"command","func":"' + "stopVideo" + '","args":""}', "*");
    });
  });
}

var browser = navigator.userAgent || navigator.vendor || window.opera;
if (
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    browser
  ) ||
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    browser.substr(0, 4)
  )
) {
  if (document.querySelector("body.page-template-pagetrialexercise")) {
    window.location = "/proefles-mobiel";
  }
}

function addSocialTrackingToUrl(orderUrl, add_params) {
  const url = new URL(orderUrl);
  console.log(url.href);
  console.log(url.origin);
  const formattedParams = Object.fromEntries(Object.entries(add_params).map(([key, val]) => [`utm_codes[]['${key}']: ${val}`]));
  const new_params = new URLSearchParams([...Array.from(url.searchParams.entries()), ...Object.entries(formattedParams)]).toString();
  console.log(new_params);
  const new_url = new URL(`${url.origin}${url.pathname}?${new_params}`);
  console.log(new_url);
  return new_url;
}

(function () {
  const primaryMenuContainer = document.getElementById("primary-menu-container");

  if (primaryMenuContainer) {
    let liElements = document.querySelectorAll("li.level-1");
    let hasActiveClass = false;

    liElements.forEach((element) => {
      if (element.classList.contains("active")) {
        hasActiveClass = true;
      }
      element.addEventListener("mouseenter", (e) => {
        document.querySelector("li.level-1.active").classList.remove("active");
        e.target.classList.add("active");
      });
    });

    if (liElements.length > 0 && !hasActiveClass) {
      liElements[0].classList.add("active");
    }
  }

  var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
  window.requestAnimationFrame = requestAnimationFrame;

  var adultOrderLinkElements = document.querySelectorAll("a[href$='/ouderversie-bestellen'], a[href$='/parental-version-order']");
  if (adultOrderLinkElements) {
    adultOrderLinkElements.forEach((orderLinkElement) => {
      orderLinkElement.setAttribute("href", "#");
      orderLinkElement.dataset.bsToggle = "modal";
      orderLinkElement.dataset.bsTarget = "#adult-order-modal";
    });
  }

  var orderLinkElements = document.querySelectorAll("a[href$='/13plus-bestellen'], a[href$='/13plus-order']");
  if (orderLinkElements) {
    orderLinkElements.forEach((orderLinkElement) => {
      orderLinkElement.setAttribute("href", "#");
      orderLinkElement.dataset.bsToggle = "modal";
      orderLinkElement.dataset.bsTarget = "#order-modal";
    });
  }

  var trialLessonLinkElements = document.querySelectorAll("a[href$='/proefles-kiezen/'], a[href$='/probelektion-waehlen/'], a[href$='/leccion-prueba/']");
  if (trialLessonLinkElements) {
    trialLessonLinkElements.forEach((trialLessonLinkElement) => {
      trialLessonLinkElement.setAttribute("href", "#");
      trialLessonLinkElement.dataset.bsToggle = "modal";
      trialLessonLinkElement.dataset.bsTarget = "#triallesson-modal";
    });
  }

  var orderNowLinkElements = document.querySelectorAll("div.order-now-url > a");
  if (orderNowLinkElements) {
    let cookie = {};
    document.cookie.split(";").forEach(function (el) {
      let [key, value] = el.split("=");
      cookie[key.trim()] = value;
    });
    if ("social-tracking" in cookie) {
      let socialTrackingCookie = decodeURIComponent(cookie["social-tracking"]);
      let socialTrackingParams = JSON.parse(socialTrackingCookie);
      orderNowLinkElements.forEach((orderNowLinkElement) => {
        let newHref = addSocialTrackingToUrl(orderNowLinkElement.getAttribute("href"), socialTrackingParams[0]);
        orderNowLinkElement.setAttribute("href", newHref);
      });
    }
  }

  // https://wpp.typetopia.com/groepskorting/
})();

const kidsbannerAlert = document.getElementById("kidsbanner");
if (kidsbannerAlert && window.Trengo) {
  if (kidsbannerAlert.classList.contains("black-friday")) {
    window.Trengo.extraOffsetY = "9rem";
  } else {
    window.Trengo.extraOffsetY = "5rem";
  }

  kidsbannerAlert.addEventListener(
    "close.bs.alert",
    function () {
      window.Trengo.extraOffsetY = "0";
    },
    {
      once: true,
    }
  );
}

var canvas = document.getElementById("typewing-canvas");

if (canvas != undefined) {
  var ctx = canvas.getContext("2d");
  canvas.height = 100;
  canvas.width = canvas.closest(".container").offsetWidth;

  var parts = [],
    minSpawnTime = 60,
    lastTime = new Date().getTime(),
    maxLifeTime = Math.min(2000, (canvas.width / (1.5 * 60)) * 1000),
    emitterX = canvas.width - 140,
    emitterY = 10,
    smokeImage = new Image();

  function spawn() {
    if (new Date().getTime() > lastTime + minSpawnTime) {
      lastTime = new Date().getTime();
      parts.push(new smoke(emitterX, emitterY));
    }
  }

  function render() {
    var len = parts.length;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    while (len--) {
      if (parts[len].y < 0 || parts[len].lifeTime > maxLifeTime) {
        parts.splice(len, 1);
      } else {
        parts[len].update();

        ctx.save();
        var offsetX = -parts[len].size / 2,
          offsetY = -parts[len].size / 2;

        ctx.translate(parts[len].x - offsetX, parts[len].y - offsetY);
        ctx.rotate((parts[len].angle / 180) * Math.PI);
        ctx.globalAlpha = parts[len].alpha;
        ctx.drawImage(smokeImage, offsetX, offsetY, parts[len].size, parts[len].size);
        ctx.restore();
      }
    }
    spawn();
    requestAnimationFrame(render);
  }

  function smoke(x, y, index) {
    this.x = x;
    this.y = y;

    this.size = 1;
    this.startSize = 32;
    this.endSize = 40;

    this.angle = Math.random() * 180;

    this.startLife = new Date().getTime();
    this.lifeTime = 0;

    this.velY = Math.floor(Math.random() * -6 + 3) / 10;
    this.velX = -1 - Math.random() * 4.5;
  }

  smoke.prototype.update = function () {
    this.lifeTime = new Date().getTime() - this.startLife;
    this.angle += 0.2;

    var lifePerc = (this.lifeTime / maxLifeTime) * 100;

    this.size = this.startSize + (this.endSize - this.startSize) * lifePerc * 0.1;

    this.alpha = 1 - lifePerc * 0.01;
    this.alpha = Math.max(this.alpha, 0);

    this.x += this.velX;
    this.y += this.velY;
  };

  smokeImage.src = "/wp-content/themes/typetopiawp/assets/images/smoke.png";

  smokeImage.onload = function () {
    canvas.width = canvas.closest(".container").offsetWidth;
    render();
  };

  window.onresize = resizeMe;
  window.onload = resizeMe;
  function resizeMe() {
    canvas.width = canvas.closest(".container").offsetWidth;
  }
}

if (document.body.classList.contains("black-friday")) {
  // Set the date we're counting down to
  var countDownWrapperElement = document.getElementById("countdown-wrapper");
  var countDownElement = document.getElementById("countdown");

  if (countDownElement) {
    var countDownDate = new Date(countDownWrapperElement.dataset.countto).getTime();

    countDownWrapperElement.classList.add("loaded");

    var daysTensNumlistElement = document.querySelector(".days.tens > .numlist");
    var daysOnesNumlistElement = document.querySelector(".days.ones > .numlist");

    var hoursTensNumlistElement = document.querySelector(".hours.tens > .numlist");
    var hoursOnesNumlistElement = document.querySelector(".hours.ones > .numlist");

    var minutesTensNumlistElement = document.querySelector(".minutes.tens > .numlist");
    var minutesOnesNumlistElement = document.querySelector(".minutes.ones > .numlist");

    var secondsTensNumlistElement = document.querySelector(".seconds.tens > .numlist");
    var secondsOnesNumlistElement = document.querySelector(".seconds.ones > .numlist");

    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var padDays = zeroPad(days, 2);
      var padHours = zeroPad(hours, 2);
      var padMinutes = zeroPad(minutes, 2);
      var padSeconds = zeroPad(seconds, 2);

      daysTensNumlistElement.className = "numlist dt-" + padDays.charAt(0);
      daysOnesNumlistElement.className = "numlist do-" + padDays.charAt(1);

      hoursTensNumlistElement.className = "numlist dt-" + padHours.charAt(0);
      hoursOnesNumlistElement.className = "numlist do-" + padHours.charAt(1);

      minutesTensNumlistElement.className = "numlist dt-" + padMinutes.charAt(0);
      minutesOnesNumlistElement.className = "numlist do-" + padMinutes.charAt(1);

      secondsTensNumlistElement.className = "numlist dt-" + padSeconds.charAt(0);
      secondsOnesNumlistElement.className = "numlist do-" + padSeconds.charAt(1);

      // Display the result in the element with id="demo"
      // document.getElementById("countdown").innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("countdown").innerHTML = "";
      }
    }, 1000);
    function zeroPad(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    }
  }
}
